import 'hammerjs';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
	dsn: environment.sentry.dsn,
	enabled: environment.sentry.active,
	environment: environment.sentry.environment,
	release: `office-web@#{PACKAGE_VERSION}-${environment.sentry.environment}`,
	beforeSend: (event) => {
		return event.fingerprint
			? event
			: { ...event, fingerprint: ['{{ message }}'] };
	},
	beforeBreadcrumb(breadcrumb) {
		if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
			const thirdParyDomains = [
				'linkedin',
				'hubspot',
				'hubapi',
				'usetiful',
				'googleapis',
				'google-analytics',
				'unleash',
				'livesession',
			];
			if (
				thirdParyDomains.some((url) => breadcrumb.data.url.includes(url)) &&
				breadcrumb.data.status_code >= 200 &&
				breadcrumb.data.status_code < 300
			) {
				return null;
			}

			if (breadcrumb.data.url.includes('./assets/i18n/')) {
				return {
					...breadcrumb,
					data: {
						...breadcrumb.data,
						url: 'Angular translate file. I18n.',
					},
				};
			}

			if (breadcrumb.data.status_code === 0) {
				return { ...breadcrumb, level: 'error' };
			}

			return breadcrumb;
		}

		return breadcrumb.category === 'ui.click' ||
			breadcrumb.category === 'console'
			? null
			: breadcrumb;
	},
	allowUrls: [
		/[\S]{1,}\.zenklub\.[\S]{1,}/, // whitelist only zenklub stuff
	],
	integrations: [
		new Sentry.BrowserTracing({
			tracePropagationTargets: [/^https:\/\/office\.zenklub\.com\.br/],
			routingInstrumentation: Sentry.routingInstrumentation,
		}),
		new Sentry.Replay(),
	],
	ignoreErrors: [
		// Applozic broken selector
		'The password is invalid or the user does not have a password.',
		'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.',
		'applozic',
		/\.mck-user-ol-status/,
		'Non-Error exception captured',
	],
	// Performance Monitoring
	tracesSampleRate: 0,
	// Session Replay
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 0,
});

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.then(() => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.register('ngsw-worker.js');
		}
	})
	.catch((err) => console.log(err));
